import React from 'react';
import { Facebook, Twitter, Instagram, Youtube, Linkedin } from 'lucide-react';

const SocialSidebar = () => {
  const socialLinks = [
    { icon: Facebook, url: 'https://www.facebook.com/share/1AZn5LojD6/', color: '#3b5998', enabled: true },
    { icon: Twitter, url: '', color: '#1da1f2', enabled: false },
    { icon: Instagram, url: '', color: '#e4405f', enabled: false },
    { icon: Youtube, url: '', color: '#ff0000', enabled: false },
    { icon: Linkedin, url: '', color: '#0077b5', enabled: false }
  ];

  return (
    <div className="fixed right-0 top-1/2 transform -translate-y-1/2 z-40 hidden md:flex flex-col shadow-lg rounded-l-lg overflow-hidden">
      {socialLinks.map((social, index) => {
        const Icon = social.icon;
        return social.enabled ? (
          <a
            key={index}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 text-white transition-all hover:pl-5"
            style={{ backgroundColor: social.color }}
          >
            <Icon size={20} />
          </a>
        ) : (
          <span
            key={index}
            className="p-3 text-white opacity-60 cursor-not-allowed"
            style={{ backgroundColor: social.color }}
          >
            <Icon size={20} />
          </span>
        );
      })}
    </div>
  );
};

export default SocialSidebar;
